import React from 'react';
import ReactDOM from 'react-dom';
import { act, Simulate } from 'react-dom/test-utils';
import QuestionListPanel from '../QuestionListPanel';
import StepProcessQuestionManager from '../StepProcessQuestionManager';
import axios from 'axios';

jest.mock('axios', () => ({ get: jest.fn(), delete: jest.fn(), post: jest.fn(), put: jest.fn() }));
jest.mock('js-cookie', () => ({ get: () => '/api/v2' }));


jest.mock('../../../stores/ToastStore', () => ({ showToast: jest.fn() }));
jest.mock('../../goal_performance/EmptyStateNotice', () => () => null);
jest.mock('../../../assets/editIcon.svg', () => 'edit');
jest.mock('../../../assets/Delete.svg', () => 'delete');
jest.mock('flexbox-react', () => ({ children }) => <div>{children}</div>);
jest.mock('../../buttons-20250224T111359Z-001/buttons', () => ({
  FilledButton: ({ text, children, onClick, disabled }) => <button onClick={onClick} disabled={disabled}>{children || text}</button>,
  TextButton: ({ text, onClick, disabled }) => <button onClick={onClick} disabled={disabled}>{text}</button>,
}));
jest.mock('@blueprintjs/core', () => ({
  Card: ({ children }) => <div>{children}</div>,
  FormGroup: ({ children }) => <div>{children}</div>,
  HTMLSelect: () => null,
  NumericInput: () => null,
  InputGroup: () => null,
  Button: ({ icon, onClick }) => <button onClick={onClick}>{icon}</button>,
  Icon: () => null,
  Popover: ({ children }) => <div>{children}</div>,
  Position: {},
  PopoverInteractionKind: {},
  Spinner: () => <span data-spinner="true" />,
  Dialog: ({ isOpen, onClose, title, children }) => isOpen ? <section role="dialog"><h2>{title}</h2><button onClick={onClose}>Close</button>{children}</section> : null,
}));

let container;
let onDeleteRemark;
let onRefresh;
let onDeleteQuestion;
let onCreateRemark;
let onUpdateRemark;
const click = element => act(() => { element.dispatchEvent(new MouseEvent('click', { bubbles: true })); });
const dialog = () => container.querySelector('[role="dialog"]');
const button = text => Array.from(container.querySelectorAll('button')).find(node => node.textContent === text);
const open = () => click(container.querySelector('.remark-actions button:last-child'));
beforeEach(() => {
  jest.clearAllMocks();
  container = document.createElement('div');
  document.body.appendChild(container);
  onDeleteRemark = jest.fn(() => Promise.resolve());
  onRefresh = jest.fn(() => Promise.resolve());
  onDeleteQuestion = jest.fn(() => Promise.resolve());
  onCreateRemark = jest.fn(() => Promise.resolve());
  onUpdateRemark = jest.fn(() => Promise.resolve());
  act(() => { ReactDOM.render(<QuestionListPanel
    questionGroups={[{ category_id: 'category-1', category_name: 'Assessment', questions: [{ id: 'question-1', question: 'How was your year?' }], comment_questions: [{ id: 'comment-1', question: 'Comment - assessment' }] }]}
    onDeleteRemark={onDeleteRemark}
    onDeleteQuestion={onDeleteQuestion}
    onCreateRemark={onCreateRemark}
    onUpdateRemark={onUpdateRemark}
    onRefresh={onRefresh}
  />, container); });
});
afterEach(() => {
  act(() => { ReactDOM.unmountComponentAtNode(container); });
  container.remove();
});

test('opening names the comment without deleting, and Cancel and cross both close it', () => {
  open();
  expect(dialog().textContent).toContain('Are you sure you want to delete Comment - assessment?');
  expect(button('Delete').disabled).toBe(false);
  expect(button('Cancel').disabled).toBe(false);
  expect(dialog().querySelector('img')).toBeNull();
  expect(onDeleteRemark).not.toHaveBeenCalled();
  click(button('Cancel'));
  expect(dialog()).toBeNull();
  open();
  click(button('Close'));
  expect(dialog()).toBeNull();
});

test('confirm deletes the selected comment once and shows the smiley after Cancel while pending', async () => {
  let resolve;
  onDeleteRemark.mockImplementation(() => new Promise(done => { resolve = done; }));
  open();
  click(button('Delete'));
  expect(onDeleteRemark).toHaveBeenCalledWith('comment-1');
  expect(onDeleteRemark).toHaveBeenCalledTimes(1);
  expect(button('Deleting...').disabled).toBe(true);
  expect(button('Cancel').disabled).toBe(true);
  expect(dialog().querySelector('button img')).toBeNull();
  expect(dialog().querySelector('[data-spinner]')).toBeNull();
  expect(button('Cancel').nextElementSibling.getAttribute('alt')).toBe('Deleting...');
  click(button('Deleting...'));
  expect(onDeleteRemark).toHaveBeenCalledTimes(1);
  await act(async () => { resolve(); });
  expect(dialog()).toBeNull();
  expect(onRefresh).toHaveBeenCalledTimes(1);
});

test('failed deletion shows backend error, restores controls and allows retry', async () => {
  const consoleError = jest.spyOn(console, 'error').mockImplementation(() => {});
  onDeleteRemark.mockRejectedValueOnce({ response: { data: { error: 'Comment could not be deleted' } } });
  open();
  await act(async () => { button('Delete').click(); });
  expect(dialog().querySelector('[role="alert"]').textContent).toBe('Comment could not be deleted');
  expect(button('Delete').disabled).toBe(false);
  expect(button('Cancel').disabled).toBe(false);
  expect(onRefresh).not.toHaveBeenCalled();
  await act(async () => { button('Delete').click(); });
  expect(onDeleteRemark).toHaveBeenCalledTimes(2);
  expect(dialog()).toBeNull();
  consoleError.mockRestore();
});


test('Step Process confirmation sends the DELETE request with cycle and step scope and refreshes the list', async () => {
  axios.get.mockImplementation(url => Promise.resolve({ data: url.endsWith('/review_questions') ? [{
    category_id: 'category-1', questions: [],
    comment_questions: [{ id: 'comment-api', question: 'API comment' }],
  }] : [] }));
  axios.delete.mockResolvedValue({ data: { message: 'Remark question deleted successfully' } });
  await act(async () => {
    ReactDOM.render(<StepProcessQuestionManager goalCycleId="cycle-1" stepProcessId="step-1" jobProfileList={[]} />, container);
  });
  open();
  expect(axios.delete).not.toHaveBeenCalled();
  await act(async () => { button('Delete').click(); });
  expect(axios.delete).toHaveBeenCalledTimes(1);
  expect(axios.delete).toHaveBeenCalledWith('/api/v2/question_categories/delete_remark_question/comment-api', {
    data: { goal_setting_id: 'cycle-1', review_process_step_id: 'step-1' },
  });
  expect(axios.get.mock.calls.filter(([url]) => url.endsWith('/review_questions'))).toHaveLength(2);
  expect(dialog()).toBeNull();
});


test('question deletion requires confirmation, names the question and permits cancel', async () => {
  click(container.querySelector('.question-actions button:last-child'));
  expect(dialog().textContent).toContain('How was your year?');
  expect(onDeleteQuestion).not.toHaveBeenCalled();
  click(button('Cancel'));
  expect(dialog()).toBeNull();
  click(container.querySelector('.question-actions button:last-child'));
  let finish;
  onDeleteQuestion.mockImplementation(() => new Promise(resolve => { finish = resolve; }));
  click(button('Delete'));
  expect(onDeleteQuestion).toHaveBeenCalledWith('question-1');
  expect(button('Deleting...').disabled).toBe(true);
  expect(button('Cancel').nextElementSibling.getAttribute('alt')).toBe('Deleting...');
  expect(dialog().querySelector('button img')).toBeNull();
  await act(async () => { finish(); });
  expect(dialog()).toBeNull();
  expect(onRefresh).toHaveBeenCalledTimes(1);
});

test('question delete failure retains the confirmation and allows retry', async () => {
  onDeleteQuestion.mockRejectedValueOnce({ response: { data: { error: 'Question is locked' } } });
  click(container.querySelector('.question-actions button:last-child'));
  await act(async () => { button('Delete').click(); });
  expect(dialog().querySelector('[role="alert"]').textContent).toBe('Question is locked');
  expect(button('Delete').disabled).toBe(false);
  await act(async () => { button('Delete').click(); });
  expect(onDeleteQuestion).toHaveBeenCalledTimes(2);
  expect(dialog()).toBeNull();
});

test.each(['add', 'edit'])('%s comment shows the smiley after Cancel only while saving and blocks duplicate requests', async mode => {
  const save = mode === 'add' ? onCreateRemark : onUpdateRemark;
  let finish;
  save.mockImplementation(() => new Promise(resolve => { finish = resolve; }));
  if (mode === 'add') click(button('+ Add Comment'));
  else click(container.querySelector('.remark-actions button:first-child'));
  expect(dialog().querySelector('img')).toBeNull();
  act(() => { Simulate.change(dialog().querySelector('input'), { target: { value: 'Updated comment' } }); });
  click(button('Save'));
  click(button('Save'));
  expect(save).toHaveBeenCalledTimes(1);
  expect(button('Cancel').nextElementSibling.getAttribute('alt')).toBe('Saving...');
  expect(button('Save').disabled).toBe(true);
  click(button('Close'));
  expect(dialog()).not.toBeNull();
  await act(async () => { finish(); });
  expect(dialog()).toBeNull();
  expect(onRefresh).toHaveBeenCalledTimes(1);
});

test('Step Process question confirmation sends scoped DELETE only after confirmation', async () => {
  axios.get.mockImplementation(url => Promise.resolve({ data: url.endsWith('/review_questions') ? [{
    category_id: 'category-1', questions: [{ id: 'question-api', question: 'API question' }], comment_questions: [],
  }] : [] }));
  axios.delete.mockResolvedValue({ data: {} });
  await act(async () => {
    ReactDOM.render(<StepProcessQuestionManager goalCycleId="cycle-1" stepProcessId="step-1" jobProfileList={[]} />, container);
  });
  click(container.querySelector('.question-actions button:last-child'));
  expect(axios.delete).not.toHaveBeenCalled();
  await act(async () => { button('Delete').click(); });
  expect(axios.delete).toHaveBeenCalledWith('/api/v2/review_questions/question-api?review_process_step_id=step-1&goal_setting_id=cycle-1');
  expect(axios.get.mock.calls.filter(([url]) => url.endsWith('/review_questions'))).toHaveLength(2);
  expect(dialog()).toBeNull();
});


test('Save Question shows a smiley after Clear, blocks duplicates and retains input on failure', async () => {
  axios.get.mockResolvedValue({ data: [] });
  let reject;
  axios.post.mockImplementation(() => new Promise((resolve, fail) => { reject = fail; }));
  await act(async () => {
    ReactDOM.render(<StepProcessQuestionManager goalCycleId="cycle-1" stepProcessId="step-1" jobProfileList={[]} />, container);
  });
  act(() => { Simulate.change(container.querySelector('textarea'), { target: { value: 'Keep my question' } }); });
  click(button('Save Question'));
  click(button('Save Question'));
  expect(axios.post).toHaveBeenCalledTimes(1);
  expect(button('Save Question').disabled).toBe(true);
  expect(button('Clear').disabled).toBe(true);
  expect(button('Clear').nextElementSibling.getAttribute('alt')).toBe('Saving...');
  await act(async () => { reject({ response: { data: { error: 'Save failed' } } }); });
  expect(container.querySelector('textarea').value).toBe('Keep my question');
  expect(button('Save Question').disabled).toBe(false);
  expect(button('Clear').nextElementSibling).toBeNull();
  axios.post.mockResolvedValue({ data: {} });
  await act(async () => { button('Save Question').click(); });
  expect(container.querySelector('textarea').value).toBe('');
});
